<template lang="pug">
.hnm
  //TAB區
  .hnmTabBlock(v-if="tabs !== null")
    .hnmTab(
      v-for="(item, index) in tabs"
      :key="item.id"
      @click="setTab(index)" 
      :class="{active: tabIndex==index}"
    ) {{ item.text }}
  .hnmContentBlock(v-if="showData !== null")
    router-link.hnmTextBlock(
      v-for="item in showData"
      :key="item.id"
      :to="'/post/' + item.id"
    )
      .hnmTitle {{ item.title }}
      .hnmDate {{ item.id.slice(0, 10)}}
      .hnmLine
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      MAX_AMOUNT: 10,
      tabIndex: 0
    }
  },
  computed: {
    showData() {
      if (this.tabs == null || this.tabs.length === 0) return []
      const data = this.tabs[this.tabIndex].data
      return data
    }
  },
  methods: {
    async setTab(index) {
      this.tabIndex = index
    },
    HtoS(s) {
      return s.replace(/<(?:.|\s)*?>/g, "").replace(/&nbsp;/ig, "").replace(/&hellip;/ig, "").replace(/&mdash;/ig, "")
    },
  }
}
</script>

<style lang="sass">
@import '@/assets/style.sass'

.hnm
  width: 95%
  height: 70vw
  min-width: 300px
  min-height: 310px
  // +bb
  background: url('../assets/newspadblock.png')
  +bgcon
  background-position: 0 0
  background-size: 100% auto
  +flexcolumn
  align-items: center
  box-sizing: border-box
  +phone
    margin-top: 5%
    height: 97vw
    background: url('../assets/hnm.png')
    background-position: 0 0
    background-size: 100% auto
    background-repeat: no-repeat

  //TAB區
  .hnmTabBlock
    width: 90%
    height: 8%
    // +bb
    +flexrow
    justify-content: space-around
    align-items: center
    +phone
      width: 85%
      height: 8%
    .hnmTab
      cursor: pointer
      position: relative
      font-size: 2.5vw
      color: #878787
      // box-sizing: border-box
      padding: 1.3% 2%
      font-weight: 800
      letter-spacing: 0.5vw
      text-align: center
      &.active
        background-color: rgba(#878787, 0.8)
        color: white
      +phone
        padding: 1.5% 2%
        font-size: 3vw


  .hnmContentBlock
    overflow: auto
    width: 90%
    height: 86%
    box-sizing: border-box
    padding: 5% 0 0 0
    // +bb
    +phone
      width: 85%
    .hnmTextBlock
      width: 96%
      height: 10%
      box-sizing: border-box
      // +bb
      +flexrow
      margin-left: 2%
      flex-wrap: wrap
      justify-content: center
      position: relative
      margin-bottom: 2%
      +phone
        margin-bottom: 0
        height: 13%
      .hnmTitle
        width: 70%
        height: 100%
        box-sizing: border-box
        // +bb
        font-size: 2.2vw
        padding: 1.3% 0 1.3% 2%
        letter-spacing: 0.4vw
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
        color: #878787
        +phone
          padding: 3.5% 0 1.3% 2%
          font-size: 3vw
          

      .hnmDate
        width: 25%
        height: 100%
        padding: 1.3% 0 1.3% 2%
        box-sizing: border-box
        // +bb
        margin-left: 3%
        color: #878787
        letter-spacing: 0.2vw
        font-size: 2.2vw
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
        +phone
          padding: 4.5% 0 1.3% 2%
          // font-size: 2vw

      .hnmLine
        width: 98%
        // height: 1%
        border: solid 0.5px #DADBDB
        // margin-bottom: 2%
      
    .hnmMore
      position: relative
      width: 16%
      height: 10%
      box-sizing: border-box
      text-align: center
      padding: 1.1% 3%
      font-size: 2.5vw
      +bb
      border-color: #DADBDB
      color: #878787
      left: 50%
      margin-left: -8%
      margin-top: 5%
      font-weight: 800
      +phone
        width: 25%
        margin-left: -12.5%
        font-size: 3.8vw
      &:active
        background-color: #878787
        color: white
      

</style>


// WEBPACK FOOTER //
// src/components/HomeNewsM.vue